import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import {
    green,
    red,
} from '@material-ui/core/colors';
import {
    CheckCircle,
    Error
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

const style = (theme) => ({
    successSnackbar: {
        backgroundColor: green[500],
    },
    errorSnackbar: {
        backgroundColor: red[500]
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    }
});

const RoofSnapSnackBar = (props) => {

    const renderSnackbarContent = () => {
        switch (props.variant) {
            case 'success':
                return (
                    <SnackbarContent
                        className={props.classes.successSnackbar}
                        message={
                            <span className={props.classes.message}>
                                <CheckCircle className={props.classes.icon} />
                                {props.message}
                            </span>
                        }
                    />
                );
            case 'error':
                return (
                    <SnackbarContent
                        className={props.classes.errorSnackbar}
                        message={
                            <span className={props.classes.message}>
                                <Error className={props.classes.icon} />
                                {props.message}
                            </span>
                        }
                    />
                );
            default:
                return (
                    <SnackbarContent
                        message={props.message}
                    />
                );
        }
    };

    return (
        <Snackbar
            onClose={props.onClose}
            open={props.open}
            autoHideDuration={3000}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
        >
            {renderSnackbarContent()}
        </Snackbar>
    );
};

RoofSnapSnackBar.propTypes = {
    variant: PropTypes.string.isRequired,
    message: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    classes: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        successSnackbar: PropTypes.string.isRequired,
        errorSnackbar: PropTypes.string.isRequired,
    }).isRequired,
};

export default withStyles(style)(RoofSnapSnackBar);
